import md5 from "blueimp-md5";

export function hashFromObj(obj) {
  return md5(JSON.stringify(obj));
}



/** WEBPACK FOOTER **
 ** ./src/common/lib/utils/hash.js
 **/